import { editor, info, widget } from '@wix/editor';
import { createClient } from '@wix/sdk';

let widgetClient: ReturnType<typeof createWidgetClient> | null = null;

const createWidgetClient = () =>
  createClient({
    host: editor.host(),
    auth: editor.auth(),
    modules: { widget },
  });

const getWidgetClient = () => {
  if (!widgetClient) {
    widgetClient = createWidgetClient();
  }
  return widgetClient;
};

export const getWidgetAccessToken = async (): Promise<string> => {
  const { headers } = await editor.auth().getAuthHeaders();
  const authorization = headers?.Authorization;

  if (!authorization) {
    throw new Error('Wix did not return an Authorization header for this widget.');
  }

  return authorization.replace(/^Bearer\s+/i, '');
};

export const setWidgetProp = async (propName: string, value: string): Promise<void> => {
  await getWidgetClient().widget.setProp(propName, value);
};

export const getViewMode = async (): Promise<string | null> => {
  try {
    return (await info.getViewMode()) ?? null;
  } catch {
    return null;
  }
};

export const getMetaSiteId = async (): Promise<string | null> => {
  try {
    return (await info.getMetaSiteId()) ?? null;
  } catch {
    return null;
  }
};

export const getThemeCustomProperties = (keys?: string[]) =>
  info.getThemeCustomProperties({ keys });

export const getSiteFonts = (keys?: string[]) => info.getSiteFonts({ keys });

export const siteHasCustomClasses = () => info.siteHasCustomClasses();

export const getSiteDirection = () => info.getSiteDirection();

export const getLanguageCode = () => info.getLanguageCode();

export const getWidgetProp = async (propName: string): Promise<string | null> => {
  try {
    const value = await getWidgetClient().widget.getProp(propName);
    return value ?? null;
  } catch {
    return null;
  }
};
